module.exports = __webpack_public_path__ + "img/RLP.66498d68.jpg";